import { useHouseholdMembersContext } from 'contexts/HouseholdMembersContext';

const useIsUnInvitedSecondaryUser = () => {
  const { isUnInvitedSecondaryUser } = useHouseholdMembersContext();

  return isUnInvitedSecondaryUser;
};

export default useIsUnInvitedSecondaryUser;
